module.exports = {
      id: "vikatanspl-usage",
      viewBox: "0 0 30.9 32",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#vikatanspl",
      toString: function () {
        return this.url;
      }
    }